import { combineReducers } from 'redux';
import PendingRequests from '../utilities/PendingRequests';
import registrationSlice from './registrationSlice';
import userSlice from './userSlice';

const appReducer = combineReducers({
  registration: registrationSlice,
  user: userSlice,
  pendingRequests: PendingRequests,
});

// const rootReducer = (state: any, action: PayloadAction<string>) => {
//   // when user logout
//   if (action.type === 'user/logout') {
//     // TODO: need to clean persist
//     // not working
//     storage.removeItem('persist:root');
//     localStorage.removeItem('persist:root');
//   }
//
//   return appReducer(state, action);
// };

export default appReducer;
